import { render } from "./ContentDisplay.vue?vue&type=template&id=aeee3130&scoped=true"
import script from "./ContentDisplay.vue?vue&type=script&lang=ts"
export * from "./ContentDisplay.vue?vue&type=script&lang=ts"

import "./ContentDisplay.vue?vue&type=style&index=0&id=aeee3130&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-aeee3130"

export default script